import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Typography,
  useTheme,
} from "@mui/material";
import { usePostHog } from "@posthog/react";
import { logOut } from "components/navigation/menu-bar";
import {
  switchedOrganisationCookieName,
  useIdentity,
} from "contexts/identity-context";
import GeoscapeDeveloperSvg from "icons/hub-logo-signIn.svg?react";
import { useCookies } from "react-cookie";
import { useLocation } from "react-router";
import { useIntercom } from "react-use-intercom";

// This page is for the users who already gone through the onboarding process, and then got no-access to their organisations.
export const NoAccessToOrganisations = () => {
  const theme = useTheme();
  const [identityState, setUserState] = useIdentity();

  const isDark = theme.palette.mode === "dark";

  const [_c, setCookie, removeCookie] = useCookies([
    switchedOrganisationCookieName,
  ]);
  const { update, shutdown } = useIntercom();
  const posthog = usePostHog();

  return (
    <>
      <div
        style={{
          backgroundRepeat: "repeat",
          backgroundSize: "cover",
          width: "100%",
          height: "100vh",
          position: "relative",
        }}
      >
        <Box
          alignItems="center"
          height="100%"
          style={{
            display: "flex",
            flexDirection: "column",
            paddingTop: "64px",
            backgroundColor: isDark ? "black" : "white",
          }}
          overflow="auto"
        >
          <Box
            display="flex"
            justifyContent="center"
            sx={{
              backgroundColor: isDark ? "black" : "white",
            }}
          >
            {useLocation().pathname !== "/sign-up" && (
              <GeoscapeDeveloperSvg
                fill={isDark ? "white" : "black"}
                style={{ width: "450px", height: "100px", padding: "0px" }}
              />
            )}
          </Box>
          <div style={{ height: "32px" }}></div>
          <Box
            sx={{
              width: "410px",
            }}
          >
            <Card>
              <CardHeader
                title="It Looks Like Your Organisation's Plan Has Changed"
                sx={{
                  width: "415px !important",
                  padding: "32px 32px 0px 32px !important",
                }}
              />
              <CardContent
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  padding: "32px 32px 16px 32px !important",
                  alignItems: "flex-start",
                  gap: "16px",
                  alignSelf: "stretch",
                }}
              >
                <Typography>
                  Your access to Hub is currently unavailable because your
                  organisation's subscription no longer supports multiple team
                  members.
                </Typography>
                <Typography>
                  Please contact your organisation's Owner. They have the
                  ability to upgrade to a plan that includes team access, which
                  will restore your account immediately.
                </Typography>
              </CardContent>
              <CardActions
                sx={{
                  paddingTop: 0,
                  paddingRight: 4,
                  paddingLeft: 4,
                  paddingBottom: 4,
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                }}
              >
                <Button
                  color="primary"
                  fullWidth
                  variant="contained"
                  onClick={() =>
                    logOut(setUserState, removeCookie, shutdown, posthog)
                  }
                >
                  Sign Out
                </Button>
              </CardActions>
            </Card>
          </Box>
        </Box>
      </div>
    </>
  );
};
